import * as _ from 'underscore'

import { UserSessionService } from '../../../../services/user-session'

import { Enums } from '../../../../models/common'
import { OperatorLayoutSetting } from '../../../../models/local'
import { OpOperator, OpProfileData } from '../../../../models/core'


//#region Public Types

export const SERVICE_NAME: string = 'ImportService'

//#endregion


//#region Private Types

type ImportSettings = {
    detailsRowsVisibleState: boolean
}

//#endregion


export class ImportService {

    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Common.Import]' }

    private static get DEFAULT_IMPORT_INPUT_PARAMS_MODE(): Enums.ImportInputParamsMode { return Enums.ImportInputParamsMode.BeforeInitialization }

    //#endregion


    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion


    //#region Config

    public loadDetailsRowsVisibleState(): boolean {
        return this.loadComponentSettings().detailsRowsVisibleState
    }

    public saveDetailsRowsVisibleState(detailsRowsVisibleState: boolean): void {
        const importSettings: ImportSettings = this.loadComponentSettings()

        importSettings.detailsRowsVisibleState = detailsRowsVisibleState

        this.saveComponentSettings(importSettings)
    }

    private loadComponentSettings(): ImportSettings {
        return this.userSessionService.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.Import), {
            detailsRowsVisibleState: false
        })
    }

    private saveComponentSettings(settings: ImportSettings): void {
        this.userSessionService.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.Import), settings)
    }

    //#endregion


    //#region ImportInputParamsMode

    public getImportInputParamsMode(): Enums.ImportInputParamsMode {
        const loggedOperator: OpOperator = this.userSessionService.getLoggedOperator()

        if (
            loggedOperator != null
            && loggedOperator.profile != null
            && loggedOperator.profile.parameters != null
        ) {
            const profileImportInputParamsModeData: OpProfileData = loggedOperator.profile.parameters.getData(Enums.DataType.PROFILE_IMPORT_INPUT_PARAMS_MODE, 0)

            if (
                profileImportInputParamsModeData != null
                && profileImportInputParamsModeData.value != null
            ) {
                return profileImportInputParamsModeData.value
            } else {
                return ImportService.DEFAULT_IMPORT_INPUT_PARAMS_MODE
            }
        } else {
            return ImportService.DEFAULT_IMPORT_INPUT_PARAMS_MODE
        }
    }

    //#endregion

}